import SectionCarousel from './SectionCarousel';
export default SectionCarousel;
